export const styles: { [key: string]: React.CSSProperties } = {
  gazableTowerControls: {
    position: "absolute",
    top: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    flexDirection: "column",
    background: "rgba(0, 0, 0, 0.3)",
    zIndex: 4,
    color: "white",
    textShadow: "-1px -1px 0 #000, 1px -1px 0 #000",
  },

  gazableTowerControlsHeader: {
    fontSize: "72px",
  },

  gazableTowerControlsType: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    gap: "20px",
  },

  gazableTowerControlsTower: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },

  gazableTowerControlsCost: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
};
